import { Flex, Center, Text } from '@chakra-ui/react';
import { ErrorIcon } from '@halo/ui-chat-react';

interface ChatPanelFooterErrorProps {
  children: React.ReactNode;
}

const ChatPanelFooterError = ({ children }: ChatPanelFooterErrorProps) => {
  return (
    <Flex
      className="ChatPanelFooterError"
      align="center"
      justify="center"
      bg="bg"
      p="4.5"
      gap="1"
      borderTop="1px solid"
      borderColor="border.subtle"
      borderBottomRadius="lg"
    >
      <Center color="fg.subtle">
        <ErrorIcon />
      </Center>
      <Text color="fg.subtle" fontSize="xs" fontWeight="medium">
        {children}
      </Text>
    </Flex>
  );
};

const MemoizedChatPanelFooterError = memo(ChatPanelFooterError);

export { MemoizedChatPanelFooterError as ChatPanelFooterError };
